const Role = {
  NO_MANAGER: 0,
  OPERATION_MANAGER: 1,
  ACCOUNT_MANAGER: 2,
  SYSTEM_MANAGER: 3,
};

/**
 * permissionの型がnumberかRoleかどうか
 */
const validPermission = (permission) => {
  if (
    permission !== Role.NO_MANAGER &&
    permission !== Role.OPERATION_MANAGER &&
    permission !== Role.ACCOUNT_MANAGER &&
    permission !== Role.SYSTEM_MANAGER
  ) {
    throw Error("invaidPermission");
  }
  return true;
};

/**
 * 権限がアカウント管理者相当(+システム管理者)かどうか
 */
export const isPermissiveAsAccountManager = (permission) => {
  validPermission(permission);
  return (
    permission === Role.ACCOUNT_MANAGER || permission === Role.SYSTEM_MANAGER
  );
};
/**
 * 権限が運用管理者相当(+システム管理者)かどうか
 */
export const isPermissiveAsOperationManager = (permission) => {
  validPermission(permission);
  return (
    permission === Role.OPERATION_MANAGER || permission === Role.SYSTEM_MANAGER
  );
};

/**
 * 管理者かどうか
 */
export const isManager = (permission) => {
  return (
    isPermissiveAsAccountManager(permission) ||
    isPermissiveAsOperationManager(permission)
  );
};

export default Role;
